import Component from 'flarum/common/Component';
export default class coreFooter extends Component {
  oninit() {
    const startYear = 2025;
    const currentYear = new Date().getFullYear();
    this.yearLabel = startYear === currentYear ? currentYear : startYear + "-" + currentYear;
  }
  oncreate() {
    let coreWaveApi = document.createElement('script');
    coreWaveApi.charset = 'utf-8';
    coreWaveApi.src = '/assets/extensions/ziiven-ziven-core/core/wave.js';
    document.head.appendChild(coreWaveApi);
  }
  getDomainFromUrl(url) {
    try {
      const urlObject = new URL(url);
      return urlObject.hostname.toUpperCase();
    } catch (error) {
      return null;
    }
  }
  view() {
    var _app$current;
    // 2026-07-31 v0.4.7.1: 1.8 mithril Stream .get() → 2.0 PageState .data.routeName
    const routeName = String(((_app$current = app.current) == null || (_app$current = _app$current.data) == null ? void 0 : _app$current.routeName) || '');
    const allowRoute = ["index", "tags", "imageShow", "group-list"].indexOf(routeName) !== -1;
    return m("footer", {
      class: "footer",
      style: allowRoute ? "" : "display:none"
    }, m("svg", {
      class: "waves",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "none"
    }, m("path", {
      id: "wavePath",
      d: "M 0 32.0727466679394 C 12.5 38.40737544511609 12.5 38.40737544511609 25 35.24006105652774 C 37.5 32.0727466679394 37.5 32.0727466679394 50 57.230496668520914 C 62.5 82.38824666910243 62.5 82.38824666910243 75 69.99999201658578 C 87.5 57.61173736406913 87.5 57.61173736406913 100 57.230496668520914  ",
      "stroke-width": "2"
    })), m("div", {
      class: "container"
    }, m("div", {
      class: "bloq"
    }, m("div", {
      class: " flex-2"
    }, m("h2", {
      class: "title"
    }, app.forum.attribute('title')), m("p", null, app.forum.attribute('description')), m("i", {
      class: "social-icon"
    }, m("a", {
      href: "https://www.facebook.com/p2000.impreza",
      target: "_blank",
      class: "social"
    }, m("i", {
      class: "fa-brands fa-weibo"
    })), m("a", {
      href: "https://twitter.com/KaiYang86975520",
      target: "_blank",
      class: "social"
    }, m("i", {
      class: "fa-brands fa-tiktok"
    })), m("a", {
      href: "https://www.instagram.com/efast1568/",
      target: "_blank",
      class: "social"
    }, m("i", {
      class: "fa-brands fa-weixin"
    })))), m("div", {
      class: "bloq-3"
    }, m("h2", {
      class: "title"
    }, app.translator.trans('ziven-community-core.forum.footer-about-us')), m("span", {
      class: "acount-icon"
    }, m("a", {
      href: "javascript:void"
    }, app.translator.trans('ziven-community-core.forum.footer-contact')), m("a", {
      href: "javascript:void"
    }, app.translator.trans('ziven-community-core.forum.footer-regulation')), m("a", {
      href: "javascript:void"
    }, app.translator.trans('ziven-community-core.forum.footer-privacy')))), m("div", {
      class: "bloq-3"
    }, m("h2", {
      class: "title"
    }, app.translator.trans('ziven-community-core.forum.footer-links')), m("span", {
      class: "acount-icon"
    }, m("a", {
      href: "javascript:void",
      target: "_blank"
    }, app.translator.trans('ziven-community-core.forum.footer-links-join')), m("a", {
      href: "javascript:void",
      target: "_blank"
    }, app.translator.trans('ziven-community-core.forum.footer-links-join')), m("a", {
      href: "javascript:void",
      target: "_blank"
    }, app.translator.trans('ziven-community-core.forum.footer-links-join')))))), m("div", {
      className: "info container"
    }, m("div", null, "Copyright \xA9 ", this.yearLabel, " ", app.forum.attribute('title'), " ", app.translator.trans('ziven-community-core.forum.footer-copyright')), m("div", null, "\u4EACICP\u59072025143831\u53F7")), m("div", {
      className: "software container"
    }, "Powered By GeeWen"));
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/coreFooter', coreFooter);